import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Row } from '../layout/flex';
import styled from '../../styles/styled';
export const BannerNotification = ({ content }) => {
    return (_jsx(StickyContainer, { children: content && _jsx(BannerWrapper, { children: content() }) }));
};
const BannerWrapper = styled(Row)(({ theme }) => ({
    padding: '16px 24px',
    height: '100%',
    boxShadow: theme.shadow.bottomLarge,
}));
const StickyContainer = styled('div')({
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 5,
    backgroundColor: 'white',
});
//# sourceMappingURL=banner_notification.js.map